<div class="btnGroup" #btn>
  <button dw-button *ngFor="let item of btnList$ | async" type="button" [attr.disabled]="(item.disabled && item.disabled())?'':null" [dwType]='item.type' (click)="clickFixedBtn(item.id)">
    <i class="{{item.icon}}"></i>
    <span translate>{{item.name}}</span>
  </button>
  <!--<ng-container >-->
    <!--<button dw-button type="button" (click)="clikMoreBtn($event)" #morebtn>-->
      <!--<span translate>更多</span>-->
    <!--</button>-->
  <!--</ng-container>-->
  <!--<div class="moreBtns" *ngIf="showBtn" [ngStyle]="currentStyles">-->
    <!--<button dw-button *ngFor="let item of btnMore" type="button" [dwType]='item.type' (click)="clickFixedBtn(item.name)">-->
      <!--<i class="anticon anticon-{{item.icon}}"></i>-->
      <!--<span translate>{{item.name}}</span>-->
    <!--</button>-->
  <!--</div>-->
  <dw-dropdown *ngIf="showMoreBtn">
    <button dw-button dw-dropdown><span>更多</span> <i class="anticon anticon-down"></i></button>
    <ul dw-menu>
      <li dw-menu-item  *ngFor="let item of btnMore" (click)="clickFixedBtn(item.id)">
        <a><i class="{{item.icon}}"></i>{{item.name}}</a>
      </li>
    </ul>
  </dw-dropdown>
</div>
